(function (Drupal) {
  Drupal.behaviors.serviceSoins = {
    attach: function (context, settings) {
      const servicesSoins = context.querySelectorAll(".services-soins");
      servicesSoins.forEach((serviceSoin) => {
        if (!serviceSoin.dataset.serviceSoinsProcessed) {
          serviceSoin.dataset.serviceSoinsProcessed = "true";

          const filterItems = context.querySelectorAll("#filter li");
          const firstFilterLink = context.querySelector(
            "#filter li:first-child a"
          );

          if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            filterItems.forEach((item) => {
              const link = item.querySelector("a");
              const letter = link ? link.textContent : null;
              if (letter === hash) {
                item.classList.add("active");
              } else if (firstFilterLink) {
                firstFilterLink.classList.add("active");
              }
            });
          }

          const filterLinks = context.querySelectorAll("#filter li a");
          filterLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
              e.preventDefault();
              filterItems.forEach((item) => item.classList.remove("active"));
              link.parentElement.classList.add("active");
            });
          });
        }
      });
    },
  };
})(Drupal);
